import { useMutation } from 'react-query';
import { postFeatureFlags } from './api';
import { FeatureFlagsRequestData } from './types';

export const useFeatureFlagsMutation = () => {
  return useMutation(['postFeatureFlags'], (data: FeatureFlagsRequestData) =>
    postFeatureFlags(data)
  );
};
